module.exports = __webpack_public_path__ + "static/img/logo_dark.016e4ec0.svg";